/**
 * PositionPicker — visual FL/FR/RL/RR selector for position-sensitive repairs
 * Used in line item form for Tires, Brakes, Suspension, Headlights
 */
export default function PositionPicker({ value, onChange }) {
  const corners = [
    ['FL', 'FR'],
    ['RL', 'RR'],
  ];
  const shortcuts = [
    { code: 'FRONT_BOTH', label: 'Both Fronts' },
    { code: 'REAR_BOTH', label: 'Both Rears' },
    { code: 'ALL_POSITIONS', label: 'All' },
  ];
  const trailers = [
    { code: 'TRAILER_FL', label: 'T-FL' },
    { code: 'TRAILER_FR', label: 'T-FR' },
    { code: 'TRAILER_RL', label: 'T-RL' },
    { code: 'TRAILER_RR', label: 'T-RR' },
  ];

  const btn = (code, label) => (
    <button
      key={code}
      type="button"
      onClick={() => onChange(value === code ? 'NONE' : code)}
      className={`px-2 py-1.5 text-[10px] font-bold font-['JetBrains_Mono'] rounded-sm border transition-all ${
        value === code
          ? 'bg-[#3B82F6] text-white border-[#3B82F6]'
          : 'bg-[#0A0F1A] text-[#8B9AAB] border-[#2D3F5E] hover:border-[#3B82F6]/50 hover:text-[#E8EAED]'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="space-y-1.5">
      {/* Axle corners */}
      <div className="grid grid-cols-2 gap-1 w-20">
        {corners.map(row => row.map(code => btn(code, code)))}
      </div>
      {/* Shortcuts */}
      <div className="flex flex-wrap gap-1">
        {shortcuts.map(({ code, label }) => btn(code, label))}
      </div>
      {/* Trailer (collapsed) */}
      <div className="flex flex-wrap gap-1">
        {trailers.map(({ code, label }) => btn(code, label))}
      </div>
    </div>
  );
}
